var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_adproject",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M466.312,11.25H462.75V7.688a.188.188,0,0,0-.188-.187h-1.124a.188.188,0,0,0-.188.188V11.25h-3.562a.188.188,0,0,0-.188.188v1.125a.188.188,0,0,0,.188.188h3.562v3.563a.188.188,0,0,0,.188.188h1.124a.188.188,0,0,0,.188-.187V12.75h3.562a.188.188,0,0,0,.188-.187V11.438A.188.188,0,0,0,466.312,11.25Z",
    transform: "translate(-451.5 -1.5)",
    fill: "#33af89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M462,1.5A10.5,10.5,0,1,0,472.5,12,10.5,10.5,0,0,0,462,1.5Zm0,19.219A8.719,8.719,0,1,1,470.719,12,8.721,8.721,0,0,1,462,20.719Z",
    transform: "translate(-451.5 -1.5)",
    fill: "#33af89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.7952820e5eda8763cc01df67f3469f71.svg";
export { ForwardRef as ReactComponent };